/**
 * Extract a medallion short code from a QR scan result.
 *
 * Accepts either:
 *   - A URL containing `/m/{CODE}` (e.g. https://pontislife.com/m/ABC123)
 *   - A raw alphanumeric code (4-10 chars)
 *
 * Returns the uppercased short code, or null if the input is invalid.
 */
export const extractShortCode = (input: string): string | null => {
  // Try /m/{CODE} pattern from QR URL
  const match = input.match(/\/m\/([A-Z0-9]+)/i);
  if (match) return match[1].toUpperCase();

  // Try raw short code (alphanumeric, 4-10 chars)
  const raw = input.trim().toUpperCase();
  if (/^[A-Z0-9]{4,10}$/.test(raw)) return raw;

  return null;
};
